import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from '../../../services/utils/images.service';
import { ServicioAdmisionesService, AdmisionAbiertaEntity, ReportAdmisionesAbiertasEntity, AgrupacionSedeAdmisionAbiertaEntity } from '../../../services/servicio-admisiones.service';
import { ServicioEntidadService, EntidadEmpresarialEntity } from '../../../services/servicio-entidad.service';
import { ServicioLoginService, LoginEntity } from '../../../services/servicio-login.service';
import { HttpErrorResponse } from '@angular/common/http';
import {ExcelService} from '../../../services/utils/excel.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reporte-admisiones-abiertas-creacion',
  templateUrl: './reporte-admisiones-abiertas-creacion.component.html',
  styleUrls: ['./reporte-admisiones-abiertas-creacion.component.css']
})
export class ReporteAdmisionesAbiertasCreacionComponent implements OnInit {

  logo: string;
  mensajeLoading: string;
  mensajeError: string;

  totalAdmisiones: number;

  fechaImpresion: Date;

  agrupacion: AgrupacionSedeAdmisionAbiertaEntity[];
  entidad: EntidadEmpresarialEntity;
  usuario: LoginEntity;

  filtrosSeleccionados: ReportAdmisionesAbiertasEntity;

  objectAdmisionAbierta: ReportAdmisionesAbiertasEntity = {};

  admisionesAbiertasEntity: AdmisionAbiertaEntity[];

  constructor(private activatedRoute: ActivatedRoute,
              private servicioEntidad: ServicioEntidadService,
              private servicioImagenes: ImagesService,
              private servicioAdmisiones: ServicioAdmisionesService,
              private servicioLogin: ServicioLoginService,
              private servicioExcel: ExcelService,
              private datepipe: DatePipe) {
    this.activatedRoute.params.subscribe(params => {
      this.objectAdmisionAbierta.codigo = params['codigoBaseDatos'];
      this.objectAdmisionAbierta.uncoSede = params['uncoSede'];
      this.objectAdmisionAbierta.uncoLogin = params['uncoLogin'];
    });
  }

  ngOnInit() { }

  public onFiltrosCompletados(obj: ReportAdmisionesAbiertasEntity) {
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo();
  }

  public onGenerarExcel(obj: ReportAdmisionesAbiertasEntity) {

    this.filtrosSeleccionados = obj;

    this.getInformacionAdmisionesForExcel();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioImagenes.getLogo(this.filtrosSeleccionados.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        this.logo = null;
        this.getEntidadEmpresarial();
        console.error('Error ReporteAdmisionesAbiertas.getLogo()', err);
      });
    } catch (e) {
      this.logo = null;
      this.getEntidadEmpresarial();
      console.error('Catch ReporteAdmisionesAbiertas.getLogo()', e);
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtrosSeleccionados.codigo,
        this.filtrosSeleccionados.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        this.entidad = data[0];
        this.getInformacionUsuario();
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.entidad = null;
        this.mensajeError = 'Error al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error ReporteAdmisionesAbiertas.getEntidadEmpresarial()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.entidad = null;
      this.mensajeError = 'Error grave al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch ReporteAdmisionesAbiertas.getEntidadEmpresarial()', e);
    }
  }

  async getInformacionUsuario() {
    try {
      this.mensajeLoading = 'Cargando información usuario ...';
      const response = await this.servicioLogin.getUsuario(this.filtrosSeleccionados.codigo, this.filtrosSeleccionados.uncoLogin);
      response.subscribe((data: LoginEntity) => {
        this.usuario = data;
        this.getInformacionAdmisiones();
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        this.usuario = null;
        console.error('Error ReporteAdmisionesAbiertas.getInformacionUsuario()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.usuario = null;
      console.error('Catch ReporteAdmisionesAbiertas.getInformacionUsuario()', e);
    }
  }

  async getInformacionAdmisiones() {
    try {
      this.mensajeLoading = 'Cargando admisiones ...';
      const response = await this.servicioAdmisiones.getAdmisionesAbiertasCreacion(this.filtrosSeleccionados.codigo, this.filtrosSeleccionados.fechaInicial,
        this.filtrosSeleccionados.fechaFinal, this.filtrosSeleccionados.sedes, this.filtrosSeleccionados.usuariosRealiza, this.filtrosSeleccionados.usuariosModifica);
        response.subscribe((data: AdmisionAbiertaEntity[]) => {
          this.agruparPorSede(data);
          this.mensajeLoading = '';
        }, (err: HttpErrorResponse) => {
          this.mensajeLoading = '';
          this.agrupacion = null;
          this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
          console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', err);
        });
    } catch (e) {
      this.mensajeLoading = '';
      this.agrupacion = null;
      this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', e);
    }
  }

  async getInformacionAdmisionesForExcel() {
    try {
      this.mensajeLoading = 'Cargando admisiones ...';
      const response = await this.servicioAdmisiones.getAdmisionesAbiertasCreacion(this.filtrosSeleccionados.codigo, this.filtrosSeleccionados.fechaInicial,
        this.filtrosSeleccionados.fechaFinal, this.filtrosSeleccionados.sedes, this.filtrosSeleccionados.usuariosRealiza, this.filtrosSeleccionados.usuariosModifica);
      response.subscribe((dataAdmisionAbiertaEntity: AdmisionAbiertaEntity[]) => {
        this.admisionesAbiertasEntity = dataAdmisionAbiertaEntity;
        const data = [];

        for (const admisionAbiertaEntity of this.admisionesAbiertasEntity) {
          const item = {
            Empresa : admisionAbiertaEntity.empresa,
            Identificación : admisionAbiertaEntity.numeroIdentificacion,
            Paciente : admisionAbiertaEntity.paciente,
            Admisión : admisionAbiertaEntity.consecutivo,
            'Fecha Adm' : this.datepipe.transform(admisionAbiertaEntity.fecha, 'dd/MM/yyyy'),
            'Inicio Servicio' : this.datepipe.transform(admisionAbiertaEntity.fechaInicial, 'dd/MM/yyyy'),
            'Fin Servicio' : this.datepipe.transform(admisionAbiertaEntity.fechaFinal, 'dd/MM/yyyy'),
            'Creación Adm' : this.datepipe.transform(admisionAbiertaEntity.fechaCreacionAdmision, 'dd/MM/yyyy HH:mm'),
            Estado : admisionAbiertaEntity.estadoAdmision,
            'Usuario Realiza' : admisionAbiertaEntity.usuarioRealiza,
            'Usuario Modifica' : admisionAbiertaEntity.usuarioModificacion,
            HC : admisionAbiertaEntity.estadoHistoria
          };
          data.push(item);
        }

        this.servicioExcel.exportAsExcelFile(data, 'Reporte admisiones abiertas creación', 'sheet');

        this.mensajeLoading = '';
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.agrupacion = null;
        this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.agrupacion = null;
      this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', e);
    }
  }

  // Auxiliares
  isAvailableHeader() {
    return !this.mensajeLoading && !this.mensajeError && this.entidad && this.entidad.unco > 0 && this.usuario && this.usuario.unco > 0;
  }

  isAvailableBody() {
    return !this.mensajeLoading && !this.mensajeError && this.agrupacion && this.agrupacion.length > 0;
  }

  isEmptyBody() {
    return !this.mensajeLoading && !this.mensajeError && this.agrupacion && this.agrupacion.length === 0;
  }

  agruparPorSede(data: AdmisionAbiertaEntity[]) {

    this.totalAdmisiones = data.length;
    this.admisionesAbiertasEntity = data;

    const grupos: AgrupacionSedeAdmisionAbiertaEntity[] = [];
    if (data && data.length > 0) {
      data.forEach((adm: AdmisionAbiertaEntity) => {
        const uncoSede = adm.uncoSede;
        const sedeIndex = grupos.findIndex((a: AgrupacionSedeAdmisionAbiertaEntity) => a.unco === uncoSede);
        if (sedeIndex === -1) {
          const grupoSede: AgrupacionSedeAdmisionAbiertaEntity = {
            unco : adm.uncoSede,
            sede : adm.sede,
            datos : [ adm ]
          };
          grupos.push(grupoSede);
        } else {
          grupos[sedeIndex].datos.push(adm);
        }
      });
    }

    this.agrupacion = grupos;
  }
}
